import axios from './interceptor';

export const VoucherService = {

  // Activate (reorder) a voucher — maps to the "reorder" action in the UI.
  activateVoucher({ id }) {
    return axios({
      method: 'put',
      url: `/api/users/vouchers/${id}/activate`
    });
  },

  // Archive a voucher (soft-delete / hide from default list view).
  archiveVoucher({ id }) {
    return axios({
      method: 'put',
      url: `/api/users/vouchers/${id}/archive`
    });
  },

  // Undo a previous archive.
  unarchiveVoucher({ id }) {
    return axios({
      method: 'put',
      url: `/api/users/vouchers/${id}/unarchive`
    });
  },

  // Cancel a voucher entirely.
  cancelVoucher({ id }) {
    return axios({
      method: 'put',
      url: `/api/users/vouchers/${id}/cancel`
    });
  },

  // returns a voucher by ID, or null if it doesnt find one
  getVoucher(id) {
    return axios({
      method: 'get',
      url: `/api/users/vouchers/${id}`
    });
  },
};
